import * as Consts from "../ts/rlAdmin.consts";
import { AccountService } from "./account-service";
import { NotifyService } from "./notify-service";

export class AclService {
    static $inject = ["$q", "accountService", "notifyService", "ACL_SERVICES_ACLS"];

    private _acls: string[];

    public get acls() {
        //console.log("getting acls");
        if (this._acls == null) {
            throw "didn't get acls yet!";
        }
        return this._acls;
    }

    public set acls(value: string[]) {
        //console.log("setting acls");
        this._acls = value;
    }

    constructor(private $q: ng.IQService, private accountService: AccountService, private notifyService: NotifyService, private ACL_SERVICES_ACLS: string[]) {
        this._acls = ACL_SERVICES_ACLS;
    }

    loadAcls(policyType: number = null) {
        var output: string[] = [];
        switch (policyType) {
            case Consts.SecurityPolicyType.Activity:
                output = this.acls.filter(s => _.startsWith(s, "acl://activity"));
                break;
            case Consts.SecurityPolicyType.Admin:
                output = this.acls.filter(s => _.startsWith(s, "acl://admin"));
                break;
            case Consts.SecurityPolicyType.Data:
                output = this.acls.filter(s => _.startsWith(s, "acl://data"));
                break;
            case Consts.SecurityPolicyType.Workflow:
                output = this.acls.filter(s => _.startsWith(s, "acl://workflow"));
                break;
            default:
                output = this.acls;
                break;
        }
        return this.$q.when(output);
    }

    loadActivityAcls() {
        return this.loadAcls(Consts.SecurityPolicyType.Activity);
    }

    loadDataAcls() {
        return this.loadAcls(Consts.SecurityPolicyType.Data);
    }

    loadWorkflowAcls() {
        return this.loadAcls(Consts.SecurityPolicyType.Workflow);
    }

    loadAdminActivityAcls() {
        return this.loadAcls(Consts.SecurityPolicyType.Admin);
    }
}